<script>
export default {
  props: {
    linkId: {
      type: String,
      default: null,
    },
    linkName: {
      type: String,
      default: "",
    },
    docId: {
      type: String,
      default: null,
    },
    docName: {
      type: String,
      default: "",
    },
    templateId: {
      type: String,
      default: null,
    },
    templateName: {
      type: String,
      default: "",
    },
    orgName: {
      type: String,
      default: "",
    },

  },
  methods:{
    //Close modal
    closeModal:function(){
      this.$parent.close();
    },
    // Open mail
    openMailTo(tgtSubjectMsg, tgtBodyMsg, tgtToEmail) {
      let subject = tgtSubjectMsg;
      let body = tgtBodyMsg.split('<BR>').join('\n');
      body = body.replace(/%22/g, '"');
      window.open(
          'mailto:?subject=' +
          encodeURIComponent(subject) +
          '&body=' +
          encodeURIComponent(body) +
          '&to=' +
          encodeURIComponent(tgtToEmail),
      );
    },
    requestUpgrade:function(){
      let requestType;
      let tgtBodyMsg ="Hey Harbour team,\n\n" +
          "I am requesting help upgrading a link/document created in the older version of your editor. Details below.\n\n" +
          "Thanks for helping with this.\n\n" +
          "-------------------------------------\n" +
          "Support request details:\n";
      if(this.docId) {
        requestType = `Document: (${this.docId})`;
        tgtBodyMsg += `- Document: ${this.docName} (${this.docId})\n`
      }
      if(this.templateId) {
        requestType = `Template: (${this.templateId})`;
        tgtBodyMsg += `- Template: ${this.templateName} (${this.templateId})\n`
      }
      if(this.linkId) {
        requestType = `link: (${this.linkId})`;
        tgtBodyMsg += `- Signer link: ${this.linkName} (${this.linkId})\n`
      }
      let orgName = `${this.orgName ? `- ${this.orgName} ` : ''}`;
      const tgtSubjectMsg = `Doc upgrade request ${orgName}- ${requestType}:`

      const tgtToEmail = "support@harbourshare.com"
      this.openMailTo(tgtSubjectMsg, tgtBodyMsg, tgtToEmail);
    }
  },
};
</script>

<template>
  <div class="upgrade-ck-modal hrbr-modal modal-card" style="width: 500px;">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <i class="fa-solid fa-arrow-up"></i>
        <span>Upgrade notice</span>
      </p>
    </header>
    <section class="modal-card-body">
      <div>
        This document was created using an older version of our editor.
        We've since launched a new editor with improved formatting and collaboration features.
        <br><br>
        You can recreate this link using the new editor—it’s already available in your account. <a href="https://knowledgebase.harbourshare.com/knowledge/templates" target="_blank">Learn how</a>.
        <br><br>If you still need help converting this document, we’re happy to assist.
        <br><br>
      </div>
    </section>
    <footer class="modal-card-foot">
      <HrbrButton :button="{ text: 'Close', styleType: 'secondary' }" @click="closeModal"/>
      <HrbrButton :button="{ text: 'Request upgrade', styleType: 'primary' }" @click="requestUpgrade"/>
    </footer>
  </div>
</template>

<style lang="postcss" scoped>
@import "@/assets/css/elements/modal.css";
.upgrade-ck-modal .modal-card-body{
  min-height: 200px;
}
</style>
